import { IconMessageChatbot } from "@tabler/icons-react";
import styles from "./AiInsights.module.css";
import Button from "../../../UI/Button/button";
import { useNavigate } from "react-router";

function InfoBlock({ label, text }) {
  return (
    <div className={styles.infoBlock}>
      <div className={styles.infoLabel}>{label}:</div>
      <div className={styles.infoText}>{text}</div>
    </div>
  );
}

export default function TalentAiSummaryCard({ data }) {
  const navigate = useNavigate();
  const aiInsights = data?.psychometricTestResult;
  const isEmpty =
    !aiInsights?.summary &&
    !aiInsights?.strengths?.length &&
    !aiInsights?.weaknesses?.length &&
    !aiInsights?.roleFit?.length;

  return (
    <div className={`${styles.card} ${styles.cardSummary}`}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconMessageChatbot size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>AI Summary</div>
            <div className={styles.cardSubtitle}>
              Generated from your psychometric test and activity
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        {(isEmpty || !data?.submittedPsychometricTest) && (
          <div className="flex flex-col gap-4 items-center justify-center">
            <p className="text-base my-4 text-[#152238] text-center">
              You have not taken the psychometric test yet
            </p>
            <p className="text-base mb-4 text-[#152238] text-center">
              Click below to take test
            </p>{" "}
            <Button variant="secondary" onClick={() => navigate("/test")}>
              {" "}
              Take Test
            </Button>
          </div>
        )}

        {!isEmpty && data?.submittedPsychometricTest && (
          <>
            <InfoBlock label="Summary" text={aiInsights?.summary} />
            <InfoBlock
              label="Strengths"
              text={aiInsights?.strengths?.join(", ")}
            />
            <InfoBlock
              label="Weaknesses"
              text={aiInsights?.weaknesses?.join(", ")}
            />
            <InfoBlock
              label="Role-fit"
              text={aiInsights?.roleFit?.join(", ")}
            />
          </>
        )}
      </div>
    </div>
  );
}
